import axiosInstance from 'api/axiosInstance';

export interface ConsultantOption {
	Id: number;
	FullName: string;
}

const searchConsultants = async (keyword: string): Promise<ConsultantOption[]> => {
	try {
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/Consultants?Id=0&SearchKeyword=${encodeURIComponent(keyword)}&Page=1&Take=2147483647`,
		);
		return Array.isArray(data) ? data : data?.Data || [];
	} catch (error) {
		console.error('[searchConsultants] Failed:', error);
		throw error;
	}
};

export default searchConsultants;
